import React from 'react';
import styled, { css } from 'styled-components';
import { standardColours, brandColours } from '../../styles';

const StyledWrapper = styled.div`
  position: relative;

  ${({ background }) => {
    if (background) {
      return css`
        background: linear-gradient(
          ${brandColours.senary} 0,
          ${brandColours.senary} 80%,
          ${standardColours.white} 80%
        );
      `;
    }
  }}

  ${({ gradientBackground }) => {
    if (gradientBackground) {
      return css`
        padding: 20px 0;
        background: linear-gradient(
          ${standardColours.transparent} 0,
          ${brandColours.senary} 5%,
          ${brandColours.senary} 95%,
          ${standardColours.transparent} 100%
        );
      `;
    }
  }}

  ${({ hasBadge }) => {
    if (hasBadge) {
      return css`
        overflow-x: hidden;
      `;
    }
  }}
`;

export const Wrapper = ({
  background,
  gradientBackground,
  hasBadge,
  children,
  ...props
}) => (
  <StyledWrapper
    background={background}
    gradientBackground={gradientBackground}
    hasBadge={hasBadge}
    {...props}
  >
    {children}
  </StyledWrapper>
);
